import { render, staticRenderFns } from "./NoDataState.vue?vue&type=template&id=3d308a99&"
import script from "./NoDataState.vue?vue&type=script&lang=js&"
export * from "./NoDataState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports